import $ from 'jquery';

$(document).ready(function() {
    var src = '';
    var data = '';
    var video = '';

    function defineItem(thisObject) {
        $('.b-full-screen__video').removeClass('show');
        if (thisObject.hasClass('js-media-image')) {
            $('.b-full-screen').find('img').attr('src', src);
            $('.b-full-screen__img').show();
        } else if (thisObject.hasClass('js-media-video')) {
            $('.b-full-screen__img').hide();
            video = $('#' + data).find('iframe').attr('src');
            $('#' + data).find('iframe')[0].src += "?autoplay=1";
            $('#' + data).addClass('show');
        }
    }

    $(document).on('click', '.js-media-item', function(e) {
        if (!((e.target).closest('.js-anchor'))) {
            src = $(this).find('img').attr('src');
            data = $(this).attr('data-video');
            defineItem($(this));
            $('body').addClass('is-modal-open');
            $('.js-full-screen').addClass('show');
        }
    });
    $(document).on('click', '.js-full-screen-close', function() {
        $('#' + data).find('iframe').attr('src', '');
        $('#' + data).find('iframe').attr('src', video);
        $('body').removeClass('is-modal-open');
        $('.js-full-screen').removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/general/full-screen.js